import { render, staticRenderFns } from "./BaseButtonMediumWhite.vue?vue&type=template&id=2d5e251e&scoped=true&"
import script from "./BaseButtonMediumWhite.vue?vue&type=script&lang=js&"
export * from "./BaseButtonMediumWhite.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonMediumWhite.vue?vue&type=style&index=0&id=2d5e251e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e251e",
  null
  
)

export default component.exports